import React, { ChangeEvent, useCallback } from 'react';
import { Switch, SwitchProps, Grid } from '@mui/material';
import cn from 'classnames';

import { useStyles } from './switch.styles';

export interface CustomSwitchProps extends SwitchProps {
	value: boolean;
	handleChange: (isChecked: boolean) => void;
	leftLabel?: string;
	rightLabel?: string;
	wrapperClass?: string;
	disabledWithoutColors?: boolean;
}

export const MuiCustomSwitch = ({
	leftLabel,
	rightLabel,
	value,
	handleChange,
	wrapperClass,
	disabledWithoutColors,
	...props
}: CustomSwitchProps) => {
	const classes = useStyles();
	const onChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>, isChecked: boolean) =>
			handleChange(isChecked),
		[handleChange],
	);

	const clickLeftLabel = useCallback(() => {
		handleChange(!(leftLabel && rightLabel) ? !value : false);
	}, [handleChange, value, leftLabel, rightLabel]);

	const clickRightLabel = useCallback(() => {
		handleChange(!(leftLabel && rightLabel) ? !value : true);
	}, [handleChange, value, leftLabel, rightLabel]);

	return (
		<Grid
			container
			alignItems="center"
			spacing={1}
			width="auto"
			className={wrapperClass}
		>
			{leftLabel && (
				<Grid
					item
					onClick={clickLeftLabel}
					className={cn(classes.title, {
						[classes.activeTitle]: !value,
					})}
				>
					{leftLabel}
				</Grid>
			)}
			<Grid item>
				<Switch
					{...props}
					value={value}
					checked={value}
					color={props.color || 'primary'}
					onChange={onChange}
					className={cn({
						[classes.preserveLeftThumbColor]: disabledWithoutColors && !value,
						[classes.preserveRightThumbColor]: disabledWithoutColors && value,
					})}
				/>
			</Grid>
			{rightLabel && (
				<Grid
					item
					onClick={clickRightLabel}
					className={cn(classes.title, {
						[classes.activeTitle]: value,
					})}
				>
					{rightLabel}
				</Grid>
			)}
		</Grid>
	);
};
